import { render, staticRenderFns } from "./RecipeCategoryForm.vue?vue&type=template&id=bc0be54a&scoped=true"
import script from "./RecipeCategoryForm.vue?vue&type=script&lang=js"
export * from "./RecipeCategoryForm.vue?vue&type=script&lang=js"
import style0 from "./RecipeCategoryForm.vue?vue&type=style&index=0&id=bc0be54a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc0be54a",
  null
  
)

export default component.exports